import { ActionList, Button, Popover } from "@shopify/polaris";
import {
    CircleCancelMajorMonotone,
    EditMajorMonotone,
} from "@shopify/polaris-icons";
import React, { Fragment, useCallback, useReducer } from "react";
import { useAppContext } from "../../context";
import { arrInvalid, getParamByRole, reducerFn } from "../../helper";
import history from "../../history";
import { isAuthorOrPicker } from "../amazon-idea/helper";
import AmazonIdeaTemplateDelete from "./actions/amazon-idea-template-delete";

export default function AmazonIdeaTemplateAction({ node }) {
    const [state, setState] = useReducer(reducerFn, {
        open: false,
        action: null,
        active: false,
    });

    const { currentUser } = useAppContext();

    const pathname = getParamByRole(currentUser);

    const handleClose = useCallback(() => {
        setState({ open: false, active: false, action: null });
    }, []);

    const handleToggle = useCallback(() => {
        setState((p) => ({
            ...p,
            active: !p.active,
        }));
    }, []);

    const handleClick = useCallback(
        (type) => () => {
            setState({ open: true, action: type });
        },
        [],
    );

    const props = {
        node,
        ids: [node.id],
        open: state.open,
        onClose: handleClose,
    };
    const actions = [
        isAuthorOrPicker(node, currentUser) && {
            content: "Update",
            icon: EditMajorMonotone,
            onAction: () => {
                history.push(
                    `/${pathname}/amazon-idea-templates/${node.id}/update`,
                );
            },
        },
        isAuthorOrPicker(node, currentUser) && {
            content: "delete",
            icon: CircleCancelMajorMonotone,
            onAction: handleClick("delete"),
        },
    ].filter(Boolean);

    const actionMarkup = {
        delete: <AmazonIdeaTemplateDelete {...props} />,
    };

    const activator = (
        <Button
            children="Actions"
            disclosure
            onClick={handleToggle}
            disabled={arrInvalid(actions)}
        />
    );

    return (
        <Fragment>
            <Popover
                activator={activator}
                onClose={handleToggle}
                active={state.active}
            >
                <ActionList items={actions} />
            </Popover>

            {actionMarkup[state.action]}
        </Fragment>
    );
}
